(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["lk-announcement"] && !Shopify.designMode) return;
  try {
    
(function(){
  document.documentElement.classList.add('lk-js');
  function init(){
    var els=document.querySelectorAll('.lk-reveal:not(.is-in)');
    if(!('IntersectionObserver' in window)){els.forEach(function(e){e.classList.add('is-in')});return}
    var io=new IntersectionObserver(function(en){en.forEach(function(x){if(x.isIntersecting){x.target.classList.add('is-in');io.unobserve(x.target)}})},{threshold:0.12});
    els.forEach(function(e){io.observe(e)});
  }
  if(document.readyState!=='loading'){init()}else{document.addEventListener('DOMContentLoaded',init)}
  document.addEventListener('shopify:section:load',init);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lk-countdown"] && !Shopify.designMode) return;
  try {
    
(function(){
  function run(){
    document.querySelectorAll('.lk-cd[data-deadline]').forEach(function(el){
      if(el.dataset.lkInit)return;el.dataset.lkInit='1';
      var end=new Date(el.dataset.deadline).getTime();if(isNaN(end))return;
      function pad(n){return String(n).padStart(2,'0')}
      function tick(){
        var d=end-Date.now();
        if(d<=0){el.hidden=true;return false}
        el.hidden=false;
        var s=Math.floor(d/1000);
        el.querySelector('[data-u=d]').textContent=pad(Math.floor(s/86400));
        el.querySelector('[data-u=h]').textContent=pad(Math.floor(s%86400/3600));
        el.querySelector('[data-u=m]').textContent=pad(Math.floor(s%3600/60));
        el.querySelector('[data-u=s]').textContent=pad(s%60);
        return true;
      }
      if(tick()){var t=setInterval(function(){if(!tick())clearInterval(t)},1000)}
    });
  }
  if(document.readyState!=='loading'){run()}else{document.addEventListener('DOMContentLoaded',run)}
  document.addEventListener('shopify:section:load',run);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lk-product-trust"] && !Shopify.designMode) return;
  try {
    
(function(){
  function addBiz(d,n){var r=new Date(d);while(n>0){r.setDate(r.getDate()+1);var w=r.getDay();if(w!==0&&w!==6)n--}return r}
  function run(){
    document.querySelectorAll('.lk-pt__ship').forEach(function(el){
      var f=new Intl.DateTimeFormat('fr-FR',{weekday:'long',day:'numeric',month:'long'});
      var now=new Date();
      var a=el.querySelector('[data-lk-from]'),b=el.querySelector('[data-lk-to]');
      if(a)a.textContent=f.format(addBiz(now,parseInt(el.dataset.min||7,10)));
      if(b)b.textContent=f.format(addBiz(now,parseInt(el.dataset.max||15,10)));
    });
  }
  if(document.readyState!=='loading'){run()}else{document.addEventListener('DOMContentLoaded',run)}
  document.addEventListener('shopify:section:load',run);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lk-video-wall"] && !Shopify.designMode) return;
  try {
    
(function(){
  function run(){
    document.querySelectorAll('[data-lk-vw] video').forEach(function(v){
      v.muted=true;v.setAttribute('playsinline','');
      if(!('IntersectionObserver' in window)){v.play&&v.play().catch(function(){});return}
      if(v.dataset.lkIo)return;v.dataset.lkIo='1';
      new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){v.play().catch(function(){})}else{v.pause()}})},{threshold:.3}).observe(v);
    });
  }
  if(document.readyState!=='loading'){run()}else{document.addEventListener('DOMContentLoaded',run)}
  document.addEventListener('shopify:section:load',run);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
